/* eslint-disable import/prefer-default-export */
/* eslint-disable import/no-cycle */
import { createActions } from 'redux-actions';
import { ROOT_SLICE } from '../constants';

const {
  setSearchText,
  setIsInitialized,
  clear,
} = createActions(
  {
    SET_SEARCH_TEXT: (searchText, { isFuzzySearch = false } = {}) => ({ searchText, isFuzzySearch }),
    SET_IS_INITIALIZED: (isInitialized) => ({ isInitialized }),
    CLEAR: () => ({})
  },
  { prefix: ROOT_SLICE }
);

export { setSearchText, setIsInitialized, clear };

export default { setSearchText, setIsInitialized, clear };
